import { motion } from "framer-motion";
import { FadeUp } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Tell us the job",
    desc: "Send photos and the address. We reply with a fair, upfront price — no surprises, no games.",
  },
  {
    n: "02",
    title: "We roll up",
    desc: "Our crew arrives on time with the bobcat, the truck, and the right tools for the work.",
  },
  {
    n: "03",
    title: "Done & clean",
    desc: "We finish the job, haul off every scrap, and leave your property cleaner than we found it.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="py-28 md:py-40 bg-[#0E2A1A] text-[#FFFFFF] relative overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 relative">
        <FadeUp>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 md:mb-24 items-end">
            <div className="md:col-span-8">
              <div className="chapter-line text-[#DA7B3C] mb-6">
                Ch. 03 · Process
              </div>
              <h2
                className="font-display text-6xl sm:text-7xl md:text-8xl lg:text-[7.5rem] leading-[0.92] tracking-[-0.03em]"
                style={{ fontWeight: 400 }}
              >
                Simple.{" "}
                <span className="italic text-[#DA7B3C]">Honest.</span>
                <br />
                Fast.
              </h2>
            </div>
            <p className="md:col-span-4 text-lg text-[#FFFFFF]/70 leading-relaxed max-w-sm">
              Three steps between you and a cleaner lot, a fresh driveway, or a
              brand new lawn.
            </p>
          </div>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {STEPS.map((s, idx) => (
            <FadeUp key={s.n} delay={idx * 0.12}>
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`step-${s.n}`}
                className="relative p-8 md:p-10 border border-[#FFFFFF]/15 h-full bg-[#0E2A1A] rounded-sm"
              >
                <div className="flex items-baseline justify-between mb-8">
                  <span
                    className="font-display text-7xl md:text-8xl text-[#DA7B3C] leading-none italic"
                    style={{ fontWeight: 400 }}
                  >
                    {s.n}
                  </span>
                  <span className="font-mono-sm text-[#FFFFFF]/50">Step</span>
                </div>
                <h3
                  className="font-display text-3xl md:text-4xl tracking-[-0.025em] mb-4 leading-tight"
                  style={{ fontWeight: 400 }}
                >
                  {s.title}
                </h3>
                <p className="text-[#FFFFFF]/70 text-base leading-relaxed">
                  {s.desc}
                </p>
                <div className="mt-8 pt-6 border-t border-[#FFFFFF]/10 flex items-center gap-3 font-mono-sm text-[#DA7B3C]">
                  <span className="block w-6 h-px bg-[#DA7B3C]" />
                  El Monos
                </div>
              </motion.div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
